import PropTypes from "prop-types";

export default function PageHead({ title, subtitle, actions }) {
  return (
    <div className="rec-page-head">
      <div>
        <h1 className="rec-page-title">{title}</h1>
        {subtitle && <p className="rec-page-sub">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}

PageHead.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  actions: PropTypes.node,
};

PageHead.defaultProps = {
  subtitle: null,
  actions: null,
};
